import React from 'react';
import { ISocialIframeProps } from './social-embed';

const YoutubeIframe: React.FC<ISocialIframeProps> = ({ src }) => (
  <iframe
    width="560"
    height="315"
    src={src}
    title="YouTube video player"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
    />
);

export default YoutubeIframe;
